import { t as ZepIcon } from "../ZepIcon-DpJgyrAI.mjs";
import { jsx, jsxs } from "react/jsx-runtime";
// src/components/MicrosoftOfficeExcelColor.tsx
const MicrosoftOfficeExcelColorIcon = ZepIcon((props) => /* @__PURE__ */ jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	...props,
	children: [
		/* @__PURE__ */ jsx("path", {
			d: "M5.321 8.57c0-1.312 1.037-2.376 2.315-2.376H20.75v13.723c0 .874-.69 1.583-1.543 1.583h-10.8c-1.704 0-3.086-1.418-3.086-3.166V8.569Z",
			fill: "url(#paint0_radial_869_1255)"
		}),
		/* @__PURE__ */ jsx("path", {
			d: "M5.321 8.57c0-1.312 1.037-2.376 2.315-2.376H20.75v13.723c0 .874-.69 1.583-1.543 1.583h-10.8c-1.704 0-3.086-1.418-3.086-3.166V8.569Z",
			fill: "url(#paint1_radial_869_1255)"
		}),
		/* @__PURE__ */ jsx("path", {
			d: "M5.321 11.209c0-1.312 1.037-2.375 2.315-2.375h6.943c-.853 0-1.543.708-1.543 1.583v3.167c0 .874-.691 1.583-1.543 1.583H8.407c-1.704 0-3.086 1.418-3.086 3.167v-7.125Z",
			fill: "url(#paint2_linear_869_1255)"
		}),
		/* @__PURE__ */ jsx("path", {
			d: "M5.321 11.209c0-1.312 1.037-2.375 2.315-2.375h6.943c-.853 0-1.543.708-1.543 1.583v3.167c0 .874-.691 1.583-1.543 1.583H8.407c-1.704 0-3.086 1.418-3.086 3.167v-7.125Z",
			fill: "url(#paint3_linear_869_1255)"
		}),
		/* @__PURE__ */ jsx("path", {
			d: "M5.321 5.666c0-1.748 1.382-3.166 3.086-3.166h6.171v6.334H8.408C6.703 8.834 5.32 10.25 5.32 12V5.666Z",
			fill: "url(#paint4_linear_869_1255)"
		}),
		/* @__PURE__ */ jsx("path", {
			d: "M5.321 5.666c0-1.748 1.382-3.166 3.086-3.166h6.171v6.334H8.408C6.703 8.834 5.32 10.25 5.32 12V5.666Z",
			fill: "url(#paint5_radial_869_1255)"
		}),
		/* @__PURE__ */ jsx("path", {
			d: "M5.321 5.666c0-1.748 1.382-3.166 3.086-3.166h6.171v6.334H8.408C6.703 8.834 5.32 10.25 5.32 12V5.666Z",
			fill: "url(#paint6_linear_869_1255)"
		}),
		/* @__PURE__ */ jsx("path", {
			d: "M14.578 2.5h4.629c.852 0 1.543.709 1.543 1.583V7.25c0 .875-.691 1.584-1.543 1.584h-4.628c-.853 0-1.544-.71-1.544-1.584V4.083c0-.874.691-1.583 1.543-1.583Z",
			fill: "url(#paint7_radial_869_1255)"
		}),
		/* @__PURE__ */ jsx("path", {
			d: "M4.421 11.472h4.886c.923 0 1.671.768 1.671 1.715v5.015c0 .947-.748 1.714-1.671 1.714H4.42c-.923 0-1.671-.767-1.671-1.714v-5.015c0-.947.748-1.715 1.671-1.715Z",
			fill: "url(#paint8_radial_869_1255)"
		}),
		/* @__PURE__ */ jsx("path", {
			d: "M4.421 11.472h4.886c.923 0 1.671.768 1.671 1.715v5.015c0 .947-.748 1.714-1.671 1.714H4.42c-.923 0-1.671-.767-1.671-1.714v-5.015c0-.947.748-1.715 1.671-1.715Z",
			fill: "url(#paint9_radial_869_1255)"
		}),
		/* @__PURE__ */ jsx("path", {
			d: "M9.027 18.107H7.758l-.796-1.538a4.13 4.13 0 0 1-.065-.128 4.316 4.316 0 0 1-.043-.114H6.84c-.02.054-.038.097-.056.13a5.917 5.917 0 0 0-.062.125l-.826 1.525H4.701l1.436-2.416L4.8 13.28H6.05l.708 1.373a4.19 4.19 0 0 1 .138.293h.013l.072-.154.079-.152.734-1.359h1.193L7.63 15.655l1.396 2.452Z",
			fill: "#fff"
		}),
		/* @__PURE__ */ jsxs("defs", { children: [
			/* @__PURE__ */ jsxs("radialGradient", {
				id: "paint0_radial_869_1255",
				cx: 0,
				cy: 0,
				r: 1,
				gradientUnits: "userSpaceOnUse",
				gradientTransform: "matrix(9 0 0 9.5 11.75 12)",
				children: [
					/* @__PURE__ */ jsx("stop", {
						offset: .06,
						stopColor: "#379539"
					}),
					/* @__PURE__ */ jsx("stop", {
						offset: .42,
						stopColor: "#297C2D"
					}),
					/* @__PURE__ */ jsx("stop", {
						offset: .7,
						stopColor: "#15561C"
					})
				]
			}),
			/* @__PURE__ */ jsxs("radialGradient", {
				id: "paint1_radial_869_1255",
				cx: 0,
				cy: 0,
				r: 1,
				gradientUnits: "userSpaceOnUse",
				gradientTransform: "matrix(9 0 0 9.5 11.75 12)",
				children: [/* @__PURE__ */ jsx("stop", {
					stopColor: "#073B10",
					stopOpacity: .698
				}), /* @__PURE__ */ jsx("stop", {
					offset: .99,
					stopColor: "#084A13",
					stopOpacity: 0
				})]
			}),
			/* @__PURE__ */ jsxs("radialGradient", {
				id: "paint5_radial_869_1255",
				cx: 0,
				cy: 0,
				r: 1,
				gradientUnits: "userSpaceOnUse",
				gradientTransform: "matrix(9 0 0 9.5 11.75 12)",
				children: [/* @__PURE__ */ jsx("stop", {
					offset: .29,
					stopColor: "#4EB43B"
				}), /* @__PURE__ */ jsx("stop", {
					offset: 1,
					stopColor: "#72CC61",
					stopOpacity: 0
				})]
			}),
			/* @__PURE__ */ jsxs("radialGradient", {
				id: "paint7_radial_869_1255",
				cx: 0,
				cy: 0,
				r: 1,
				gradientUnits: "userSpaceOnUse",
				gradientTransform: "matrix(9 0 0 9.5 11.75 12)",
				children: [/* @__PURE__ */ jsx("stop", {
					offset: .44,
					stopColor: "#79E96D"
				}), /* @__PURE__ */ jsx("stop", {
					offset: 1,
					stopColor: "#D0EB76"
				})]
			}),
			/* @__PURE__ */ jsxs("radialGradient", {
				id: "paint8_radial_869_1255",
				cx: 0,
				cy: 0,
				r: 1,
				gradientUnits: "userSpaceOnUse",
				gradientTransform: "matrix(9 0 0 9.5 11.75 12)",
				children: [/* @__PURE__ */ jsx("stop", { stopColor: "#20A85E" }), /* @__PURE__ */ jsx("stop", {
					offset: .94,
					stopColor: "#09442A"
				})]
			}),
			/* @__PURE__ */ jsxs("radialGradient", {
				id: "paint9_radial_869_1255",
				cx: 0,
				cy: 0,
				r: 1,
				gradientUnits: "userSpaceOnUse",
				gradientTransform: "matrix(9 0 0 9.5 11.75 12)",
				children: [/* @__PURE__ */ jsx("stop", {
					offset: .58,
					stopColor: "#33A662",
					stopOpacity: 0
				}), /* @__PURE__ */ jsx("stop", {
					offset: .97,
					stopColor: "#98F0B0",
					stopOpacity: .302
				})]
			}),
			/* @__PURE__ */ jsxs("linearGradient", {
				id: "paint2_linear_869_1255",
				x1: 2.75,
				y1: 12,
				x2: 20.75,
				y2: 12,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ jsx("stop", { stopColor: "#52D17C" }), /* @__PURE__ */ jsx("stop", {
					offset: .33,
					stopColor: "#4AA647"
				})]
			}),
			/* @__PURE__ */ jsxs("linearGradient", {
				id: "paint3_linear_869_1255",
				x1: 2.75,
				y1: 12,
				x2: 20.75,
				y2: 12,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ jsx("stop", {
					stopColor: "#29852F",
					stopOpacity: .302
				}), /* @__PURE__ */ jsx("stop", {
					offset: .5,
					stopColor: "#4AA647",
					stopOpacity: 0
				})]
			}),
			/* @__PURE__ */ jsxs("linearGradient", {
				id: "paint4_linear_869_1255",
				x1: 2.75,
				y1: 12,
				x2: 20.75,
				y2: 12,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ jsx("stop", { stopColor: "#66D052" }), /* @__PURE__ */ jsx("stop", {
					offset: 1,
					stopColor: "#85E972"
				})]
			}),
			/* @__PURE__ */ jsxs("linearGradient", {
				id: "paint6_linear_869_1255",
				x1: 2.75,
				y1: 12,
				x2: 20.75,
				y2: 12,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ jsx("stop", {
					offset: .18,
					stopColor: "#C0E075",
					stopOpacity: 0
				}), /* @__PURE__ */ jsx("stop", {
					offset: 1,
					stopColor: "#D1EB95"
				})]
			})
		] })
	]
}));
export { MicrosoftOfficeExcelColorIcon };
